import React from 'react';
import styled from 'styled-components';

import DelimitedInput from 'components/DelimitedInput';
import { LegacyInput } from 'components/LegacyInput';

const InputContainer = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  width: 100%;
  position: relative;
  align-items: center;
`;

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/function-component-definition
const DollarInput = ({
  type,
  ...props
}: {
  'data-qa-id': string;
  id?: string;
  hasError?: boolean;
  type?: string;
  name?: string;
  value?: string | number;
  placeholder?: string;
  errorMessage?: string;
  min?: number | string;
  max?: number | string;
  step?: string;
  required?: boolean;
  onChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
}) => {
  const InputComponent = type === 'number' ? LegacyInput : DelimitedInput;
  return (
    <InputContainer>
      <InputComponent
        height="100%"
        width="100%"
        pl="32px"
        type={type}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
      />
    </InputContainer>
  );
};

// eslint-disable-next-line import/no-default-export
export default DollarInput;
